import React from "react";
import sampleLicenseFront from "../../../assets/sampleIdFront.png";
import sampleLicenseBack from "../../../assets/sampleIdBack.png";
import samplePassportFront from "../../../assets/samplePassportFront.png";
import samplePassportBack from "../../../assets/samplePassportBack.png";
import { withModal } from "../";

const idTips = [
  "Steady, focused image - sharp and no motion blur",
  "ID occupies most of image and is squared in the frame",
  "Text, barcodes, and small markings are easily visible",
  "Plain black, white, or solid-color background",
  "All four edges and corners visible within frame",
  "Minimum resolution of ~1200 pixels on the shortest side",
  "Good natural lighting (average pixel intensity ~150, no flash)",
  "Name, address & DOB match those supplied in earlier steps",
  "Full color (no black and white images)",
  "Max file size of around 2 MB"
];

const passportTips = [
  "Passports: 'Front' is the bio data page, 'Back' is the signature page (see below)",
  "Steady, focused image - sharp and no motion blur",
  "Passport occupies most of image and is squared in the frame",
  "Text, barcodes, and small markings are easily visible",
  "Plain black, white, or solid-color background",
  "All four edges and corners visible within frame",
  "Minimum resolution of ~1200 pixels on the shortest side",
  "Good natural lighting (average pixel intensity ~150, no flash)",
  "Name, address & DOB match those supplied in earlier steps",
  "Full color (no black and white images)",
  "Max file size of around 2 MB"
];

const VerificationTipsModal = ({ context: { closeModal }, ...rest }) => (
  <div
    className="relative bg-white outline-none w-auto h-auto p-10 max-h-screen overflow-auto"
    style={{ maxHeight: 600 }}
  >
    <div className="text-center text-2xl p-8">{`Verification Tips - ${
      rest.useLicense ? "Licenses" : "Passports"
    }`}</div>
    <div className="w-5/6 m-auto">
      <p>Follow these tips for best results:</p>
      <ul className="list-disc pt-4">
        {(rest.useLicense ? idTips : passportTips).map(tip => (
          <li>{tip}</li>
        ))}
      </ul>
      <div className="pt-6">
        <p className="pb-4">An example of a good photo:</p>
        {rest.useLicense ? (
          <div className="text-center">
            Front
            <img className="m-auto mb-4" src={sampleLicenseFront} />
            Back
            <img className="m-auto" src={sampleLicenseBack} />
          </div>
        ) : (
          <div className="text-center">
            Front (bio page)
            <img className="m-auto mb-4" src={samplePassportFront} />
            Back (signature page)
            <img className="m-auto" src={samplePassportBack} />
          </div>
        )}
      </div>
    </div>
    <button
      className="absolute top-0 right-0 bg-gray-200 text-white text-2xl m-1 w-10 h-10"
      onClick={closeModal}
    >
      x
    </button>
  </div>
);

export default withModal(VerificationTipsModal);
